import objectHelper from "@/classes/helpers/objectHelper";

export default class ResultatSimulation {
  garantie;

  cotisationMensuelle = 0;
  cotisationMensuelleApresEmployeur = 0;
  cotisationPreleveeSurBulletinDePaie = 0;
  cotisationPreleveeSurCompteBancaire = 0;

  capitalDeces = {
    montant: 0,
    pourcentageCouverture: 0,
    renteEducation0a18: 0,
    renteEducation19a27: 0,
  };

  maladie = {
    pourcentageCouverture: 0,
    ordinaire: {
      pleinTraitement: 0,
      resteAChargePleinTraitement: 0,
      demiTraitement: 0,
      resteAChargeDemiTraitement: 0,
    },
    longueMaladieGraveMaladie: {
      pleinTraitement: 0,
      resteAChargePleinTraitement: 0,
      demiTraitement: 0,
      resteAChargeDemiTraitement: 0,
    },
    longueDuree: {
      pleinTraitement: 0,
      resteAChargePleinTraitement: 0,
      demiTraitement: 0,
      resteAChargeDemiTraitement: 0,
    },
  };

  invalidite = {
    pourcentageCouverture: 0,
    categorie1: 0,
    resteAChargeCategorie1: 0,
    categorie2et3: 0,
    resteAChargeCategorie2et3: 0,
    montantDe: 0,
    resteAChargeMontantDe: 0,
    montantA: 0,
    resteAChargeMontantA: 0,
  };

  constructor(data) {
    if (data) {
      objectHelper.assignOnlyExisting(this, data);
    }
  }
}
